import { render } from "./elem-icon.vue?vue&type=template&id=9275961c&ts=true"
import script from "./elem-icon.vue?vue&type=script&lang=ts"
export * from "./elem-icon.vue?vue&type=script&lang=ts"

import "./elem-icon.vue?vue&type=style&index=0&id=9275961c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__